export default "__VITE_ASSET__DcZCr2qi__"